import { createTheme } from "@mantine/core";
import "./fonts.css";

export const theme = createTheme({
  fontFamily: "Louis George Cafe, sans-serif",
  headings: {
    fontFamily: "MintSans, sans-serif",
    sizes: {
      h1: {
        fontSize: "1.8rem",
      },
    },
  },
  colors: {
    orange: [
      "#fff0e2",
      "#ffdfcc",
      "#ffbe9c",
      "#fc9b67",
      "#fa7d3a",
      "#fa6a1d",
      "#fa600c",
      "#df4f01",
      "#c74500",
      "#ae3900",
    ],
    yellow: [
      "#ffdc54",
      "#ffd02e",
      "#ffc400",
      "#e6b200",
      "#cc9e00",
      "#b38b00",
      "#997700",
      "#806400",
      "#665000",
      "#4d3c00",
    ],
    lightBlue: [
      "#00c3d9",
      "#00b3c4",
      "#00a3b0",
      "#00949c",
      "#008488",
      "#007474",
      "#006460",
      "#00544c",
      "#004438",
      "#003424",
    ],
    pink: [
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
      "#e88392",
    ],
    lightGreen: [
      "#a8f599",
      "#98e589",
      "#88d579",
      "#78c569",
      "#68b559",
      "#58a549",
      "#489539",
      "#489539",
      "#489539",
      "#489539",
    ],
  },
  black: "#151e27",
  /** Put your mantine theme override here */
});
